import React from 'react'
import { useEffect, useState } from 'react'
import { SEditor, SDrawerOrModal } from 'shj-components'
import { Form, Input, Select, message, TreeSelect, InputNumber } from 'antd'
import {
  submitInvalid,
  getDataCloseTree,
  getRegionLists,
  getBudGetEnums,
} from '@/services/customerServices'
import styles from './index.module.less'
import { trimStr } from '@/utils/data.ts'
import { callInvValid } from '@/services/callCenter'
import { dfs } from '@/utils/common.ts'

const TextArea = Input.TextArea

export default function SubmitInvalidModal({
  editId = '',
  open = false,
  buttonKey = '',
  onClose = () => {},
  reload = () => {},
}) {
  const [form] = Form.useForm()
  const [dictionaryData, setDictionaryData] = useState({})
  const [region, setRegion] = useState([])
  const [invalidReasonTree, setInvalidReasonTree] = useState<Array<any>>([])
  const [formKey, setFormKey] = useState(1)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchDictionaryData()
    getRegionCommons()
    fetchInvalidReason()
  }, [])

  const fetchDictionaryData = async () => {
    try {
      const resList: any = await Promise.allSettled([getBudGetEnums()])
      const map = {
        budget: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
      }
      setDictionaryData(map)
    } catch (err) {
      console.log(err)
    }
  }

  const getRegionCommons = async () => {
    try {
      const res = await getRegionLists()
      if (res) {
        setRegion(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const fetchInvalidReason = async () => {
    try {
      const res = await getDataCloseTree({
        enabled: true,
      })
      if (Array.isArray(res)) {
        setInvalidReasonTree(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getResonStr = (item: any, values: any) => {
    let str = item?.label
    if (values?.[item?.object?.key] && item?.children?.length) {
      item?.children?.forEach(reason => {
        if (reason?.object?.key === values?.[item?.object?.key]) {
          str = str + '-' + getResonStr(reason, values)
        }
      })
    }
    return str
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      if (!values.remark) {
       return message.error('请填写说明')
      }
      let reasonDesc: any = ''
      invalidReasonTree.forEach(reason => {
        if (reason?.object?.key === values.reason) {
          reasonDesc = getResonStr(reason, values)
        }
      })
      const selectedCode: any[] = []
      // 查找选择的 code 路径
      dfs(invalidReasonTree, d => {
        if (values[d.object.key] || values[d.key]) {
          selectedCode.push(values[d.object.key])
        }
      })
      // 最后一个作为 reasonCode
      const reasonCode = selectedCode[selectedCode.length - 1]
      // console.log('values', values, invalidReasonTree, reasonCode)
      // return ;
      // console.log('reasonDesc--->', reasonDesc, values)
      setLoading(true)

      callInvValid({
        clueId: editId,
        // buttonKey,
        // ...values,
        desc: values.remark,
        reasonDesc,
        reasonCode: reasonCode || values?.reason || '',
        cityAreaCode: values.cityCode,
      })
        .then(res => {
          message.success(res.message || '提交无效成功')
          onClose()
          reload()
        })
        .finally(() => setLoading(false))
    })
    .catch(({errorFields}) => {
      message.error(errorFields?.[0]?.errors?.[0])
    })
  }

  const renderExtraItem = (key: string) => {
    if (
      form.getFieldValue(key) === 'transferCity' ||
      form.getFieldValue(key) === 'nonServiceArea'
    ) {
      return (
        <Form.Item
          name="cityCode"
          label={form.getFieldValue(key) === 'transferCity' ? '转移城市' : '城市'}
          rules={[{ required: true, message: '省市不能为空' }]}
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <Select
              showSearch
              optionFilterProp={'regionName'}
            placeholder={'请选择城市'}
            fieldNames={{ label: 'regionName', value: 'regionCode' }}
            options={region}
          />
        </Form.Item>
      )
    }
    if (form.getFieldValue(key) === 'CustomerBudget') {
      return (
        <Form.Item
          name="budget"
          label="装修预算"
          rules={[
            {
              required: true,
              message: '请填写装修预算',
            },
          ]}
          style={{
            width: '100%',
          }}
        >
          <Select
            placeholder={'请选择'}
            fieldNames={{ label: 'description', value: 'key' }}
            options={dictionaryData['budget']}
          />
        </Form.Item>
      )
    }
    if (form.getFieldValue(key) === 'InteriorArea2') {
      return (
        <Form.Item
          name="innerArea"
          label="套内面积"
          rules={[
            {
              required: true,
              message: '请填写套内面积',
            },
          ]}
          style={{
            width: '100%',
          }}
        >
          <InputNumber
            style={{ width: '100%' }}
            placeholder={'请输入套内面积'}
            precision={2}
            min={0}
            max={999999999}
          />
        </Form.Item>
      )
    }
    return null
  }

  const renderRecur = (key: string, renderList = []) => {
    // 这里逻辑比较复杂，简单来说根据树递归渲染表单元素，只有当上一级的选择项，等于当前渲染子集中item的key时，才渲染下一级item，这里会涉及到form实例值的变化问题，form实例中的值一直都是存在的，get时form根据item自己做了过滤处理
    return (
      <div>
        {renderList &&
          renderList?.length !== 0 &&
          renderList.map((item: any) => (
            <div>
              {form.getFieldValue(key) === item?.object?.key && item?.children && (
                <Form.Item
                  name={item?.object?.key}
                  label={item?.object?.name}
                  rules={[
                    {
                      required: true,
                      message: `请选择${item?.object?.name}`,
                    },
                  ]}
                  style={{
                    width: '100%',
                  }}
                >
                  <Select
                    placeholder={`请选择${item?.object?.name}`}
                    options={item?.children?.map(item => ({
                      label: item?.object?.name,
                      value: item?.object?.key,
                    }))}
                  />
                </Form.Item>
              )}
              {form.getFieldValue(key) === item?.object?.key &&
                item?.children &&
                renderRecur(item?.object?.key, item?.children as any)}
              {form.getFieldValue(key) === item?.object?.key && renderExtraItem(item?.object?.key)}
            </div>
          ))}
      </div>
    )
  }

  const onFormFieldsChange = changedValues => {
    if (
      changedValues?.[0]?.name?.[0] === 'remark' ||
      changedValues?.[0]?.name?.[0] === 'innerArea'
    ) {
      return
    }
    setFormKey(formKey + 1)
    // 这里可以根据changedValues进行重新渲染等操作
  }

  return (
    <div className={styles.submitInvalidModal}>
      <SDrawerOrModal
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={500}
        title="提交无效"
      >
        <Form
          form={form}
          key={formKey}
          name="basicInfo"
          layout="vertical"
          onFieldsChange={onFormFieldsChange}
        >
          <Form.Item
            name="reason"
            label="无效原因"
            required={true}
            rules={[
              {
                required: true,
                message: '请选择无效原因',
              },
            ]}
            style={{
              width: '100%',
            }}
          >
            <Select
              placeholder={'请选择无效原因'}
              options={invalidReasonTree?.map(item => ({
                label: item?.object?.name,
                value: item?.object?.key,
              }))}
            />
          </Form.Item>
          <div>{renderRecur('reason', invalidReasonTree as any)}</div>
          <Form.Item
            name="remark"
            label="说明"
            required={true}
            rules={[
              {
                required: true,
                message: '请填写说明',
              },
            ]}
            style={{
              width: '100%',
            }}
          >
            <TextArea
              placeholder={'请填写说明'}
              rows={3}
              maxLength={200}
              showCount
              onChange={e => form.setFieldValue('remark', trimStr(e.target.value))}
            />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
